// extracted by mini-css-extract-plugin
export default {"content":"RulesModal_content__bKSSB","autoApprove":"RulesModal_autoApprove__zK5J3"};